import * as React from 'react'
import Helmet from 'react-helmet'
import { ThemeProvider } from '../styles/styled-components'

import '../styles/normalize'

import { theme } from '../styles/theme'
import LayoutRoot from '../components/LayoutRoot'
import LayoutMain from '../components/LayoutMain'

if (typeof window !== 'undefined') {
  require('webfontloader').load({
    google: {
      families: ['Open Sans:400,600:latin'],
    },
  })
}

interface WrapperProps {
  children: () => any
  data: {
    site: {
      siteMetadata: {
        title: string
        siteUrl: string
        description: string
      }
    }
  }
}

const IndexLayout: React.SFC<WrapperProps> = ({ children, data }) => (
  <LayoutRoot>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: data.site.siteMetadata.description },
        { name: 'keywords', content: 'capp, spin, cappasity, contest, vote' },
        { property: 'og:title', content: data.site.siteMetadata.title },
        { property: 'og:url', content: data.site.siteMetadata.siteUrl },
      ]}
    />
    <ThemeProvider theme={theme}>
      <LayoutMain>{children()}</LayoutMain>
    </ThemeProvider>
  </LayoutRoot>
)

export default IndexLayout

export const query = graphql`
  query IndexLayoutQuery {
    site {
      siteMetadata {
        title
        siteUrl
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.tsx